const VETA_CENTER_READINESS_ITEMS_QUERY_KEY = 'vetaCenterReadinessItems';

export const getVetaCenterReadinessItemsQueryKey = (companyId: string) => [
  VETA_CENTER_READINESS_ITEMS_QUERY_KEY,
  companyId,
];
